import React, { useState, useEffect } from "react";
import { useHistory, Redirect } from "react-router-dom";
import "../styleguide.css";
import "./LoginPage.css";
// import "./assets/login.scss";
import Loader from "react-loader-spinner";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { uAPIlocal } from "./lib/config";
// import { uAPI, IP } from "./config/Config";
// import logo from "./images/bio_logo.png";
// import bg316 from "./images/bg316.png";
import queryString from "query-string";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
// import { useCookies } from "react-cookie";

import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import { v4 as uuidv4 } from "uuid";
import frame2 from "../assets/frame2.svg";
import logo from "../assets/logo.svg";
import frame1 from "../assets/frame1.svg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useCookies } from "react-cookie";
import parse from "html-react-parser";
import Cookies from "js-cookie";

export default function Login() {
  const instance = axios.create({
    withCredentials: true,
  });

  const location = useHistory().location;
  const query = queryString.parse(location.search);
  const history = useHistory();

  // const [rememberMe, setRememberMe] = React.useState();
  // const [login, setLogin] = React.useState(
  //     localStorage.rememberMe ? true : false
  // );
  // const [detail_login, setDetail_login] = React.useState(
  //     localStorage.rememberMe
  //         ? JSON.parse(localStorage.getItem("detail_login"))
  //         : null
  // );

  const [login, setLogin] = React.useState(false);
  const [detail_login, setDetail_login] = React.useState(null);

  const [hidden, setHidden] = React.useState(true);
  const [loader, setLoader] = React.useState(false);
  const [login_alert, setLogin_alert] = React.useState(
    history.location.login_alert ? history.location.login_alert.msg : null,
  );

  const [captcha, setCaptcha] = React.useState(false);
  const [dcaptcha, setDcaptcha] = React.useState(false);
  const [dcaptchaText, setDcaptchaText] = React.useState(false);
  const [loginNotif, setLoginNotif] = React.useState(false);
  const [recentUser, setRecentUser] = React.useState();
  const [statusAlert, setStatusAlert] = React.useState(
    history.location.status ? history.location.status : null,
  );
  // const [loginSession, setLoginSession] = React.useState();

  const INITIAL_STATE = {
    username: "",
    password: "",
  };

  const [state, setState] = React.useState(INITIAL_STATE);
  const { username, password } = state;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [displayReset, setDisplayReset] = React.useState("block");
  const [overlay, setOverlay] = React.useState("none");
  const [CSRFToken, setCSRFToken] = React.useState();
  const [cookies, setCookie, removeCookie] = useCookies();
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });
  const [pathname, setPathname] = React.useState("/admin");

  const loginError = async (msg) => {
    await swalWithBootstrapButtons
      .fire({
        icon: "error",
        title: msg,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      })
      .then(function () {
        setLoader(false);
      });
  };

  const loginSuccess = async (msg) => {
    await swalWithBootstrapButtons
      .fire({
        icon: "success",
        title: msg,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      })
      .then(function () {
        setLoader(false);
        setLogin(true);
      });
  };

  const swalSuccess = async (msg) => {
    await swalWithBootstrapButtons.fire({
      icon: "success",
      title: msg,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
  };

  const [tomail, settomail] = useState("");
  const re =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  /**
   * sendmail digunakan untuk validasi email yang akan direset
   * dimulai dengan pengecekan format email, membandingkan antara
   * state tomail dan variabel re jika format benar selanjutnya
   * email dikirim untuk validasi
   * apakah email yang diinput valid atau terdaftar?
   */

  async function sendmail() {
    if (re.test(String(tomail)) === false) {
      loginError("Format email salah!");
    } else {
      //  setDisplayReset("none");
      setOverlay("flex");
      await instance
        .get(uAPIlocal + "/auth_email?email=" + tomail.toLowerCase())
        .then((response) => {
          const status = response.status;
          if (status !== 200) {
            loginError(response.text);
            setDisplayReset("block");
            setOverlay("none");
          } else {
            // setRecentUser(JsonData.name);
            console.log(response.data[0].name)
            requestResetPass(response.data[0].name);
          }
        })
        .catch((error) => {
          loginError("Terjadi Kesalahan!");
        });
    }
  }

  async function requestResetPass(name) {
    let uuid = await uuidv4();
    console.log("UUID", name);
    await instance
      .post(uAPIlocal + "/api/v1/requestResetPass", {
        email: tomail.toLowerCase(),
        kode_unik: uuid,
        status: 0,
      })
      .then((response) => {
        console.log("response", response.data);
        // nodemailer(uuid, name);
      })
      .catch((error) => {
        loginError("Terjadi Kesalahan!");
      });
  }

  async function nodemailer(key, name) {
    await instance
      .post(uAPIlocal + "/api/v1/mail", {
        username: name,
        tomail: tomail,
        url:
          "http://" +
          window.location.hostname +
          ":3000" +
          "/reset-password?token=" +
          key,
      })
      .then((response) => {
        if (response.data.msg === "success") {
          setDisplayReset("block");
          setOverlay("none");
          handleClose();
          swalSuccess("Berhasil Dikirim!");
        } else if (response.data.msg === "fail") {
          alert("Oops, something went wrong. Try again");
          setDisplayReset("block");
        }
      });
  }

  function onClose_() {
    setLoader(false);
    setLogin(true);
  }

  function toggleShow() {
    setHidden(!hidden);
  }

  function onChange(e) {
    if (e.target.autocomplete) e.target.setAttribute("autocomplete", "off");
    console.log(e.target.autocomplete);
    console.log(e.target.value);
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  }

  function onChangeRemember(e) {
    // setRememberMe(e.target.checked);
  }

  const [crp, setCrp] = useState(null);

  function openModal() {
    Swal.fire({
      title:
        '<strong style={{fontFamily: "Montserrat"}}>Syarat & Ketentuan</u></strong>',
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },

      html:
        '<p style={{fontFamily: "Montserrat"}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.' +
        "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, " +
        "when an unknown printer took a galley of type and scrambled it to make a type specimen book. " +
        "It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.,</p>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
      confirmButtonAriaLabel: "Thumbs up, great!",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
      cancelButtonAriaLabel: "Thumbs down",
    });
  }

  useEffect(() => {
    console.log("ini history", location);

    // setTimeout(function () {
    //     document.getElementById(`_username`).value = "";
    //     document.getElementById(`_password`).value = "";
    // }, 1000);

    if (!localStorage.getItem("loginStatus") && cookies["biomedika-csrf"]) {
      // alert("ini work")
      // document.cookie = "biomedika-session" + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      // Cookies.remove("biomedika-session", { path: '/', domain: '.biomedika.co.id' })
      // Cookies.remove("biomedika-login", { path: '/', domain: '.biomedika.co.id' })
      // Cookies.remove("biomedika-csrf", { path: '/', domain: '.biomedika.co.id' })
      // Cookies.remove("biomedika-userID", { path: '/', domain: '.biomedika.co.id' })
      // Cookies.remove("biomedika-level", { path: '/', domain: '.biomedika.co.id' })
      // Cookies.remove("biomedika-exp", { path: '/', domain: '.biomedika.co.id' })
      // Cookies.remove("biomedika-session", { path: '/' })
      // Cookies.remove("biomedika-login", { path: '/' })
      // Cookies.remove("biomedika-csrf", { path: '/' })
      // Cookies.remove("biomedika-userID", { path: '/' })
      // Cookies.remove("biomedika-level", { path: '/' })
      // Cookies.remove("biomedika-exp", { path: '/' })
    }

    if (captcha === false && cookies["biomedika-login"] == null) {
      setCaptcha(true);
    }

    if (username != "" || password != "") {
      setCaptcha(true);
    }

    if (captcha === false && cookies["biomedika-login"] == null) {
      getCaptcha();
    }

    if (loginNotif === false && login_alert != null) {
      // alert("kondisi 1")
      swalWithBootstrapButtons.fire({
        icon: statusAlert == "logout" ? "success" : "error",
        title: login_alert,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      // setTimeout(function () {
      //     setLogin_alert(null)
      // }, 1000);
    }

    if (localStorage.getItem("loginStatus") === "logout") {
      swalWithBootstrapButtons.fire({
        icon: localStorage.getItem("_type") == 1 ? "success" : "error",
        title:
          localStorage.getItem("_type") == 1
            ? "Berhasil Log Out"
            : "Sesi Berakhir, silahkan login kembali!",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      setTimeout(function () {
        localStorage.clear();
        sessionStorage.clear();
      }, 2000);
    }

    // if (login_alert != null && cookies["biomedika-login"] == null) {
    //     alert("kondisi 2")
    //     setLoginNotif(true);
    //     setCaptcha(true);
    // }

    // if (login_alert != null) {
    //     setLoginNotif(true);
    //     setCaptcha(true);
    // }
  });

  const getCaptcha = async () => {
    await instance
      .get(uAPIlocal + "/getCaptcha")
      .then((response) => {
        // console.log("test", response.data);
        setDcaptcha(response.data.captcha);
        setDcaptchaText(response.data.text);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  async function getValidateCaptcha(e) {
    e.preventDefault();
    setLoader(true);
    let user_captcha = document.getElementById("captha").value;
    if (user_captcha) {
      // off
      if (user_captcha == dcaptchaText) {
        document.getElementById("captha").value = "";
        getCaptcha();
        onSubmit(e);
      } else {
        loginError("Hasil captcha salah, mohon ulangi!");
        document.getElementById("captha").value = "";
        getCaptcha();
      }
      // var _url = uAPIlocal + "/getValidateCaptcha?captcha=" + user_captcha;
      // await instance
      //     .get(_url)
      //     .then((response) => {
      //         console.log("ini response", response)
      //         document.getElementById("captha").value = "";
      //         getCaptcha();
      //         onSubmit(e);
      //     })
      //     .catch((error) => {
      //         loginError("Hasil captcha salah, mohon ulangi!");
      //         document.getElementById("captha").value = "";
      //         getCaptcha();
      //     });
    } else {
      await loginError("Mohon Isi Captcha!");
      document.getElementById("captha").value = "";
    }
  }

  async function onSubmit(e) {
    e.preventDefault();
    setLoader(true);
    var _url =
      uAPIlocal +
      "/app/login?username=" +
      username +
      "&password=" +
      encodeURIComponent(password);
    if (username === "" && password === "") {
      await loginError("PID dan password harus diisi!");
    } else {
      await instance
        .get(_url)
        .then((response) => {
          console.log("response", response.data);
          return response.data;
        })
        .then((JsonData) => {
          // console.log(JsonData);
          const status = JsonData.status;

          let fa = [];
          if (JsonData.feature_access) {
            fa = JsonData.feature_access.split(",");
          }

          if (fa.length > 1) {
            setTimeout(() => {
              history.push("/menu");
            }, 3000);
          } else {
            if (fa.includes("1") == true) {
              localStorage.setItem("page", "klinik");
              if (JsonData.level == 1 || JsonData.level == 3) {
                setTimeout(() => {
                  history.push("/admin/master-record");
                }, 3000);
              } else if (JsonData.level == 2 || JsonData.level == 4) {
                setTimeout(() => {
                  history.push("/admin/master-exam");
                }, 3000);
              } else {
                setTimeout(() => {
                  history.push("/admin/master-record");
                }, 3000);
              }
            } else if (fa.includes("2") == true) {
              localStorage.setItem("page", "rujukan");
              if (JsonData.level != 2) {
                setTimeout(() => {
                  history.push("/pasien");
                }, 3000);
              } else if (JsonData.level == 2 && JsonData.logintype == 2) {
                setTimeout(() => {
                  history.push("/sregistration");
                }, 3000);
              } else if (JsonData.level == 2 && JsonData.logintype != 2) {
                setTimeout(() => {
                  history.push("/registration");
                }, 3000);
              }
            } else {
            }
          }

          if (status !== 200) {
            loginError(status);
          } else {
            let randomKey = Array(6)
              .fill(0)
              .map((x) => Math.random().toString(36).charAt(2))
              .join("");
            setDetail_login({
              d_u: CryptoJS.AES.encrypt(
                JsonData.id.toString(),
                randomKey,
              ).toString(),
              kode_perusahaan: JsonData.kode_perusahaan,
              nama_perusahaan: JsonData.nama_perusahaan,
              idp: JsonData.Company_ID,
              nama_user: JsonData.name,
              p_: randomKey,
              level: JsonData.level.toString(),
              branch: JsonData.branch_name,
              lt_: JsonData.logintype,
            });

            let xjson = {
              d_u: CryptoJS.AES.encrypt(
                JsonData.id.toString(),
                randomKey,
              ).toString(),
              kode_perusahaan: JsonData.kode_perusahaan,
              nama_perusahaan: JsonData.nama_perusahaan,
              idp: JsonData.Company_ID,
              nama_user: JsonData.name,
              p_: randomKey,
              level: JsonData.level.toString(),
              branch: JsonData.branch_name,
              lt_: JsonData.logintype,
            };

            loginSuccess("Login berhasil!");
            localStorage.status_login = true;
            localStorage.setItem("Company_ID", JsonData.Company_ID);
            localStorage.setItem("_log", JSON.stringify(xjson));
            localStorage.setItem("login", true);
            localStorage.setItem("name", JsonData.name);
            localStorage.setItem("branch", JsonData.branch_code);
            localStorage.setItem("_fa", JsonData.feature_access);

            if (JsonData.level == 2) {
              localStorage.setItem("id_dokter", JsonData.ID_DOKTER);
            }

            // setTimeout(() => {
            //     window.location.reload();
            // }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
          loginError("Terjadi Kesalahan!");
        });
    }
  }

  if (cookies["biomedika-login"] != null && Cookies.get("biomedika-level")) {
    let fa = [];
    if (localStorage.getItem("_fa")) {
      fa = localStorage.getItem("_fa").split(",");
    }

    if (fa.length > 1) {
      return <Redirect to={{ pathname: "/menu" }} />;
    } else {
      if (fa.includes("1") == true) {
        localStorage.setItem("page", "klinik");
        if (
          Cookies.get("biomedika-level") == 1 ||
          Cookies.get("biomedika-level") == 3
        ) {
          return <Redirect to={{ pathname: "/admin/master-record" }} />;
        } else if (
          Cookies.get("biomedika-level") == 2 ||
          Cookies.get("biomedika-level") == 4
        ) {
          return <Redirect to={{ pathname: "/admin/master-exam" }} />;
        } else {
          return <Redirect to={{ pathname: "/admin/master-record" }} />;
        }
      } else if (fa.includes("2") == true) {
        localStorage.setItem("page", "rujukan");
        if (Cookies.get("biomedika-level") != 2) {
          return <Redirect to={{ pathname: "/pasien" }} />;
        } else if (
          Cookies.get("biomedika-level") == 2 &&
          JSON.parse(localStorage.getItem("_log")).lt_ == 2
        ) {
          return <Redirect to={{ pathname: "/sregistration" }} />;
        } else if (
          Cookies.get("biomedika-level") == 2 &&
          JSON.parse(localStorage.getItem("_log")).lt_ != 2
        ) {
          return <Redirect to={{ pathname: "/registration" }} />;
        }
      } else {
      }
    }
  }

  // alert(Cookies.get("_login"))

  // return (
  //     <>

  //         <div className="container" style={{ maxWidth: '100%' }}>

  //             <div class="content" >

  //                 <div className="row">
  //                     <div className="col-6 p-5">
  //                         <div className="col-12 rounded bg-info p-5">1</div>
  //                     </div>
  //                     <div className="col-6 p-5">
  //                         <div className="col-12 rounded bg-info p-5">1</div>
  //                     </div>

  //                 </div>
  //             </div>

  //         </div>

  //     </>
  // );

  return (
    <>
      {/* reset password */}
      <div id="overlay" style={{ display: overlay }}>
        <div className="w-100 d-flex justify-content-center align-items-center">
          <div className="sk-chase">
            <div className="sk-chase-dot"> </div>
            <div className="sk-chase-dot"> </div>
            <div className="sk-chase-dot"> </div>
            <div className="sk-chase-dot"> </div>
            <div className="sk-chase-dot"> </div>
            <div className="sk-chase-dot"> </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        dialogClassName="custom-modal"
        keyboard
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#0b6e51" }}>
          <Modal.Title
            style={{ fontSize: 18, color: "white", fontFamily: "Montserrat" }}
          >
            Reset Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="App">
              <div className="form-group mb-3">
                <div className="text-center d-flex justify-content-between mt-4">
                  <p style={{ fontFamily: "Montserrat" }}>Masukkan Username</p>
                </div>
                <input
                  className="num-09-input-field-instance-new"
                  placeholder=""
                  type="text"
                  name="new_password"
                  id="myInput"
                  onChange={(e) => {
                    settomail(e.target.value);
                  }}
                  autoComplete="off"
                />
              </div>

              <div className="submit-button">
                {state.loader ? (
                  <Loader
                    type="Circles"
                    color="#00BFFF"
                    height={40}
                    width={100}
                  />
                ) : (
                  <div className="accordion-reset">
                    <input
                      type="submit"
                      onClick={sendmail}
                      name=""
                      style={{ display: displayReset }}
                      value="Kirim"
                      className="num-03-filled-button-instance-1-new"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
          <div className="back-button-mini">
            <input type="button" name="" onClick={handleClose} value="CLOSE" />
          </div>
        </Modal.Footer>
      </Modal>

      <div className="Auth-form-container">
        {/* <img alt='image1' className="frame-2-new" src={frame2} />*/}
        <form className="Auth-form" onSubmit={getValidateCaptcha}>
          <div className="Auth-form-content">
            <Row>
              <div
                className="col-12 d-flex justify-content-center text-center"
                style={{ marginBottom: "20px" }}
              >
                <img alt="image2" className="logo-new" src={logo} />
              </div>

              {/* <div className="col-12 d-flex justify-content-center text-center">
                                {
                                    message ? (
                                        <div className="alert alert-danger alert-dismissible">{message}</div>
                                    ) : null
                                }
                            </div> */}
            </Row>

            {/* <h3 className="Auth-form-title">Sign In</h3> */}
            <div className="form-group mt-3">
              <label className="label-new"> ID / USERNAME </label>
              <input
                id="_username"
                name="username"
                type="text"
                className="num-09-input-field-instance-new"
                placeholder="Enter PID"
                onChange={onChange}
                autoFocus
                autoComplete="off"
                required
              />
            </div>
            <div className="form-group mt-3 icon-div">
              <label className="label-new"> PASSWORD </label>
              <input
                id="_password"
                type={hidden ? "password" : "text"}
                className="num-09-input-field-instance-new"
                placeholder="******"
                name="password"
                onChange={onChange}
                autoComplete="off"
                required
              />

              <a href="#" className="psw_child" onClick={toggleShow}>
                {hidden === true ? (
                  <i className="fa fa-eye"> </i>
                ) : (
                  <i className="fa fa-eye-slash"> </i>
                )}
              </a>
              {/* 
                            <br />
                            <input
                                id="captha"
                                name="captha"
                                type="text"
                                placeholder="Enter Captha"
                                required
                                autoFocus
                                autoComplete="off"
                                // className="form-control rounded-pill border-0 px-4"
                                className="num-09-input-field-instance-new"
                                style={{
                                    // background: "#CCD9DD",
                                    // fontFamily: "var(--font-family-gotha-boo)",
                                    fontSize: 14,
                                    // fontWeight: "bold",
                                    // boxShadow: "0px 4px 7px #8989",
                                    transition: "0.6s ease",
                                }}
                            // onChange={onChange}
                            />
                            <br />
                            <LoadCanvasTemplate
                                reloadText="Reload Captcha"
                                reloadColor="blue"
                            /> */}
            </div>
            <div className="row justify-content-end">
              {/* <div className="col-6">
                                <div className="form-group mt-3 icon-div">


                                    <input
                                        id="captha"
                                        name="captha"
                                        type="text"
                                        placeholder="Enter Captha"
                                        required
                                        autoFocus
                                        autoComplete="off"
                                        // className="form-control rounded-pill border-0 px-4"
                                        className="num-09-input-field-instance-new"
                                        style={{
                                            // background: "#CCD9DD",
                                            // fontFamily: "var(--font-family-gotha-boo)",
                                            fontSize: 14,
                                            // fontWeight: "bold",
                                            // boxShadow: "0px 4px 7px #8989",
                                            transition: "0.6s ease",
                                        }}
                                    // onChange={onChange}
                                    />
                                    <br />

                                </div>
                            </div> */}

              {/* <div className="col-6">
                                <div className="form-group mt-3 icon-div">

                                    <div style={{ transform: "scale(1.2)", transformOrigin: "0 0" }}>

                                        <LoadCanvasTemplate
                                            reloadText="Reload Captcha"
                                            reloadColor="blue"
                                        />
                                    </div>

                                </div>
                            </div> */}

              <Row>
                <div
                  className="col-6 d-flex justify-content-center text-center"
                  style={{ marginBottom: "20px" }}
                >
                  <div>{parse(dcaptcha ? dcaptcha : "")} </div>
                </div>

                <div
                  className="col-6 d-flex justify-content-center text-center"
                  style={{ marginBottom: "20px" }}
                >
                  <input
                    id="captha"
                    name="captha"
                    type="number"
                    placeholder="hasil..."
                    required
                    autofocus
                    className="num-09-input-field-instance-new"
                    onChange={onChange}
                  />
                </div>
              </Row>


              {/*<Row>
              <div className="col-12  d-flex justify-content-center text-center">
                <a
                  href="#"
                  style={{
                    fontSize: "12px",
                    float: "right",
                    color: "#1C4D6A",
                    fontWeight: "bold",
                    fontFamily: "var(--font-family-gotha-bol)",
                    marginTop: "3px",
                  }}
                  onClick={handleShow}
                >
                  Forgot Password?
                </a>
              </div>
               </Row>*/}
            </div>
           

            {/* <div className="form-group mt-3 icon-div" style={{ marginBottom: '40px' }}>
                            <a
                                href="#"
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    fontFamily: 'Montserrat',
                                    textDecoration: 'none',
                                    position: 'absolute',
                                    right: 0,
                                    top: '-12px'
                                }}
                                onClick={handleShow}
                            >
                                Lupa Password?
                            </a>
                        </div> */}
            <div className="d-grid gap-2 mt-3">
              {state.loader ? (
                +(
                  <Loader
                    type="Circles"
                    color="#00BFFF"
                    height={40}
                    width={100}
                  />
                )
              ) : (
                <button
                  type="submit"
                  className="num-03-filled-button-instance-1-new"
                >
                  {" "}
                  <p className="fontlogin"> Log In </p>
                </button>
              )}
            </div>
            {/* <p className="text-right mt-2">
                            <a href="#" style={{ fontFamily: 'Montserrat' }} onClick={openModal}>Syarat & Ketentuan</a>
                        </p> */}
          </div>
        </form>
        {/*<img alt='image12' className="frame-1-new" src={frame1} />*/}
      </div>

      {/* <div className="container-fluid">
                <div className="row no-gutter">

                    <div className="col-md-5">
                        <div className="login d-flex align-items-center py-4">
                            <div className="container">
                                <div className="row">
                                    <div
                                        className="col"
                                        style={{
                                            marginTop: 60,
                                            marginLeft: 50,
                                            marginRight: 50,
                                        }}
                                    >
                                        <p className="title">User Login</p>
                                        <p className="mb-4 welcome">Welcome</p>
                                        <form onSubmit={login_}>
                                            <div className="form-group mb-3">
                                                <div className="text-center d-flex justify-content-between">
                                                    <p className="input_label">Email</p>
                                                </div>
                                                <input
                                                    id="inputEmail"
                                                    name="email_user"
                                                    type="email"
                                                    placeholder="Email address"
                                                    required
                                                    autoFocus
                                                    autoComplete="off"
                                                    className="form-control rounded-pill border-0 px-4"
                                                    onChange={onChange}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <div className="text-center d-flex justify-content-between mt-4">
                                                    <p className="input_label">Password</p>
                                                </div>
                                                <input
                                                    className="form-control rounded-pill border-0 px-4"
                                                    required
                                                    placeholder="************"
                                                    type={hidden ? "password" : "text"}
                                                    name="password"
                                                    id="myInput"
                                                    onChange={onChange}
                                                    autoComplete="off"
                                                />

                                                <div>
                                                    <a href="#" className="psw_child" onClick={toggleShow}>
                                                        {hidden === true ? (
                                                            <i className="fa fa-eye"></i>
                                                        ) : (
                                                            <i className="fa fa-eye-slash"></i>
                                                        )}
                                                    </a>
                                                </div>

                                                <br />
                                                <input
                                                    id="captha"
                                                    name="captha"
                                                    type="text"
                                                    placeholder="Enter Captha"
                                                    required
                                                    autoFocus
                                                    autoComplete="off"
                                                    className="form-control rounded-pill border-0 px-4"
                                                    style={{
                                                        background: "#CCD9DD",
                                                        fontFamily: "var(--font-family-gotha-boo)",
                                                        fontSize: 14,
                                                        fontWeight: "bold",
                                                        boxShadow: "0px 4px 7px #8989",
                                                        transition: "0.6s ease",
                                                    }}
                                                // onChange={onChange}
                                                />
                                                <br />
                                                <LoadCanvasTemplate
                                                    reloadText="Reload Captcha"
                                                    reloadColor="blue"
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-6 mx-auto">
                                                    <div className="custom-checkbox mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={state.rememberMe}
                                                            name="remember"
                                                            onChange={onChangeRemember}
                                                            style={{
                                                                marginLeft: "20px",
                                                                left: "-2px",
                                                                top: "1px",
                                                                width: "10px",
                                                                position: "absolute",
                                                            }}
                                                        />{" "}
                                                        <p
                                                            style={{
                                                                display: "inline-block",
                                                                fontSize: "12px",
                                                                color: "#1C4D6A",
                                                                fontWeight: "bolder",
                                                                marginLeft: "20px",
                                                                fontFamily: "var(--font-family-gotha-bol)",
                                                            }}
                                                        >
                                                            Remember Me
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-6 mx-auto">
                                                    <a
                                                        href="#"
                                                        style={{
                                                            fontSize: "12px",
                                                            float: "right",
                                                            color: "#1C4D6A",
                                                            fontWeight: "bold",
                                                            fontFamily: "var(--font-family-gotha-bol)",
                                                            marginTop: "3px",
                                                        }}
                                                        onClick={handleShow}
                                                    >
                                                        Forgot Password?
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="submit-button text-center">
                                                    {state.loader ? (
                                                        <Loader type="Circles" color="#00BFFF" height={40} width={100} />
                                                    ) : (
                                                        <div className="login-button">
                                                            <input type="submit" name="" value="LOGIN" />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            {/* <ToastContainer
    position="bottom-right"
    autoClose={1000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
   /> */}
    </>
  );
}
